export enum BroadcastsRouteName {
    Broadcasts = 'broadcasts',
    Create = 'broadcasts-create'
}
